import { extractDbIdFromGraphqlId } from '../../../util/string'
import { BusinessSubscriptionQueryResponse, SubscriptionOrganization } from './BusinessCalendarQueries'

// Pure gating helpers for the Business Calendar billing loop (Task 6). These
// live in their own module (no React/router imports) so they're unit-testable
// in the node jest env — and because they're the exact place a regression would
// silently re-bounce a lapsed owner to the marketing landing / "Calendar Not
// Found". Both are re-exported from their owning components for callers.

/**
 * Orgs to show in the calendar list. Includes any org that has *ever*
 * subscribed (active/trialing/past_due/canceled) so lapsed owners keep a path
 * back to their dashboard (recovery banner / reactivate screen). The marketing
 * landing only shows when the user has no subscription at all.
 */
export function getCalendars(data: BusinessSubscriptionQueryResponse | undefined): SubscriptionOrganization[] {
  if (!data?.currentUser?.organizationMemberships) return []

  return data.currentUser.organizationMemberships
    .filter(m => !!m.organization.businessSubscription)
    .map(m => m.organization)
}

/**
 * Resolve any org the user belongs to that has a subscription, by database id,
 * regardless of status. past_due/canceled orgs must reach the dashboard
 * instead of falling through to "Calendar Not Found".
 */
export function findSubscriptionOrgById(
  data: BusinessSubscriptionQueryResponse | undefined,
  organizationId: string
): { organization: SubscriptionOrganization; role: string } | null {
  if (!data?.currentUser?.organizationMemberships) return null

  const membership = data.currentUser.organizationMemberships.find(m => {
    const orgDbId = extractDbIdFromGraphqlId(m.organization.id)
    return orgDbId === organizationId && !!m.organization.businessSubscription
  })

  return membership ? { organization: membership.organization, role: membership.role } : null
}
